import { Loader2 } from 'lucide-react';

/**
 * Lightweight loading skeleton shown while lazy-loaded route chunks download.
 * Designed to match the layout shell so the transition feels seamless.
 */
export function PageSkeleton() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        <span className="text-sm text-muted-foreground">Loading...</span>
      </div>
    </div>
  );
}
